<template>
  <div class="conversation-item" :class="activeClass" @click="handleActive">
    <span class="m-badge m-badge-status">
      <span v-if="avatar">
        <el-badge v-if="session.unread && session.unread !== 0" :value="session.unread" class="item">
          <span class="m-avatar m-avatar-span">
            <img :src="avatar" alt="" />
          </span>
        </el-badge>
        <span v-else class="m-avatar m-avatar-span">
          <img :src="avatar" alt="" />
        </span>
      </span>
      <span v-else>
        <el-badge v-if="session.unread && session.unread !== 0" :value="session.unread" class="item">
        <span class="m-avatar m-avatar-icon">
          <span class="m-avatar-string">{{ nickName[0] }}</span>
        </span>
        </el-badge>
        <span v-else class="m-avatar m-avatar-icon">
          <span class="m-avatar-string">{{ nickName[0] }}</span>
        </span>
      </span>
    </span>
    <div class="conversation-item-content">
      <div class="conversation-item-content-name">{{ nickName }}</div>
      <div class="conversation-item-content-msg">
        <div class="conversation-item-content-msg-body">
          <span>{{ lastMsgText }}</span>
        </div>
      </div>
    </div>
    <div class="conversation-item-state">
      <div class="conversation-item-state-date">{{ lastMsgTime }}</div>
      <div class="conversation-item-state-mute"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: 'ConversationItem',
  props: {
    session: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: ''
    }
  },
  computed: {
    ...mapState({
      imUserProfiles: state => state.imUserProfiles,
      imActiveAccount: state => state.imActiveAccount,
      imAccount: state => state.imAccount,
      imTeams: state => state.imTeams
    }),
    activeClass () {
      return this.isActive ? 'active' : ''
    },
    nickName () {
      if (this.session.scene === 'p2p' || this.session.scene === 'bot') {
        return this.imUserProfiles[this.session.to] && this.imUserProfiles[this.session.to].nick ? this.imUserProfiles[this.session.to].nick : this.session.to
      } else {
        return this.imTeams[this.session.to] && this.imTeams[this.session.to].name ? this.imTeams[this.session.to].name : ''
      }
    },
    avatar () {
      if (this.session.scene === 'p2p') {
        return this.imUserProfiles[this.session.to] && this.imUserProfiles[this.session.to].avatar ? this.imUserProfiles[this.session.to].avatar : null
      } else if (this.session.scene === 'bot') {
        return 'https://cdn.pixabay.com/photo/2020/08/19/00/13/sea-5499649_1280.jpg'
      } else {
        return this.imTeams[this.session.to] && this.imTeams[this.session.to].avatar ? this.imTeams[this.session.to].avatar : null
      }
    },
    lastMsgText () {
      let text = '\u00A0'
      if (!this.session.lastMsg) return text
      if (this.session.lastMsg.type === 'text') {
        text = this.session.lastMsg.text
      } else if (this.session.lastMsg.type === 'image') {
        text = '[图片消息]'
      } else if (this.session.lastMsg.type === 'file' && this.session.lastMsg.file) {
        text = '[文件]'
      } else if (this.session.lastMsg.type === 'audio' && this.session.lastMsg.file) {
        text = '[音频]'
      } else if (this.session.lastMsg.type === 'video' && this.session.lastMsg.file) {
        text = '[视频]'
      } else if (this.session.lastMsg.type === 'notification') {
        text = '[通知]'
      } else if (this.session.lastMsg.type === 'custom') {
        text = '[自定义消息]'
      }

      if (this.session.lastMsg.scene === 'team' && this.session.lastMsg.type !== 'notification') {
        text = this.session.lastMsg.fromNick + '：' + text
      }

      return text
    },
    lastMsgTime () {
      if (this.session.lastMsg) {
        return this.formatTimestampToTime(this.session.lastMsg.time)
      }
      return ''
    },
    notifyMsg (msg) {
      if (msg.attach && msg.attach.type === 'addTeamMembers') {
        let ownerId = msg.attach.team.owner
        let ownerName = ownerId === this.imAccount.im_accid ? '你' : this.imUserProfiles[ownerId].name
      }
    },
  },
  watch: {
  },
  methods: {
    ...mapActions(['resetCurrSession']),
    handleActive () {
      if (this.session.unread > 0) {
        this.$store.dispatch('reduceImUnreadCountAction', this.session.unread).then(() => {
          this.resetCurrSession(this.imActiveAccount).then(() => {
            this.$emit('active-change', this.session)
          })
        })
        return
      }

      this.resetCurrSession(this.imActiveAccount).then(() => {
        this.$emit('active-change', this.session)
      })
      // this.$emit('before-click', this.session)
      // this.$emit('active-change', this.session)
    },
    formatTimestampToTime (timestamp) {
      const date = new Date(timestamp)
      // const year = date.getFullYear()
      // const month = String(date.getMonth() + 1).padStart(2, '0')
      // const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style lang="stylus" scoped>
.conversation-item {
  display: flex;
  padding: 12px;
  position: relative;
  cursor: pointer;
  transition: all .3s cubic-bezier(.645,.045,.355,1);
  align-items: center;
}
.m-badge-status {
  line-height: inherit;
  vertical-align: baseline;
}
.m-badge {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, .85);
  font-size: 14px;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnim";
  position: relative;
  display: inline-block;
}
.m-avatar {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  vertical-align: middle;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: inline-block;
  overflow: hidden;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  border-radius: 8px;
}
.m-avatar>img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.m-avatar-span {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  vertical-align: middle;
}
.conversation-item-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 6px 0 10px;
  flex: 1;
  min-width: 0;
  line-height: normal;
}
.conversation-item-content-name {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.conversation-item-content-msg {
  font-size: 12px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.conversation-item-content-msg-body {
  font-size: 12px;
  color: #999999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.conversation-item-state {
  display: flex;
  flex-direction: column;
  width: fit-content;
  align-items: flex-end;
  white-space: nowrap;
}
.conversation-item-state-date {
  font-size: 12px;
  color: #999999;
}
.conversation-item-state-mute {
  color: #656a72;
  height: 22px;
}
.active {
  background-color: #ccc;
}
.m-avatar-icon {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 18px;
  vertical-align: middle;
  background-color: rgb(190, 101, 217);
}
.m-avatar-string {
  line-height: 36px;
  transform: scale(0.777778) translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/ConversationItem.vue